import React, { useState } from 'react';
import Button from '../Button';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Toast from '../Toast';
import { StyledDeleteTeamModal } from './DeleteTeamModal.style';
import teamService from '../../services/teamService';

const DeleteTeamModal = ({ onClose, _id, refetch }) => {
  const queryClient = useQueryClient();

  const removeTeam = useMutation({
    mutationFn: async id => {
      return await teamService.deleteTeam(id);
    },
    onSuccess: response => {
      onClose();
      Toast({
        type: 'success',
        message: response.detail,
      });
      refetch();
      queryClient.invalidateQueries({ queryKey: ['teams'] });
    },
    onError: err => {
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  return (
    <StyledDeleteTeamModal>
      <div className="holder">
        <strong className="title">Delete your Team?</strong>
        <p>Your Team will be permanently removed from Feeda.ai</p>
      </div>
      <div className="btn-holder">
        <Button width="140px" variant="secondary-outline" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button width="200px" variant="danger" loader={removeTeam?.isPending} onClick={() => removeTeam.mutate(_id)}>
          Delete Permanently
        </Button>
      </div>
    </StyledDeleteTeamModal>
  );
};

export default DeleteTeamModal;
